/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';
import {
  FORM_KEYS,
  // CLIENT_CLASSIFICATION,
  // TYPE_OF_INVESTMENT
} from 'shared/constant';

const {
  // GOAL,
  INVESTMENT_PURPOSE,
  RISK_TOLERANCE,
  INVESTMENT_PREFERENCE,
  INDEPENDENT_PROF_ADVICE,
  // INSIDER_STATUS,
  // INVESTMENT_OBJECTIVE_TIME_HORIZON,
  // ASSET_CLASSES,
  // MARKETS,
  // INVESTMENT_KNOWLEDGE,
  // RESTRICTIONS,
  // OTHER_RESTRICTION,

  // Investment Experience
  INVESTMENT_EXP_BONDS_YRS,
  INVESTMENT_EXP_EQUITIES_YRS,
  INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS,
  INVESTMENT_EXP_REAL_ESTATE_YRS,
  INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS,

  INSIDER_STATUS_LIST,
  INSIDER_STATUS_LIST_COMPANY,
  INSIDER_STATUS_LIST_POSITION,
} = FORM_KEYS.CLIENT_PROFILE_FORM;

// isDiscretionary, restrictions, clientClassification, typeOfInvestment
export const clientProfileFormSchema = (intl, elementName) => {
  switch (elementName) {
    // case GOAL:
    //   return yup.object().shape({
    //     [GOAL]: yup
    //       .string()
    //       .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.goal' }) })),
    //   });
    case INVESTMENT_PURPOSE:
      return yup.object().shape({
        [INVESTMENT_PURPOSE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentPurpose' }) })),
      });
    case RISK_TOLERANCE:
      return yup.object().shape({
        [RISK_TOLERANCE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.riskTolerance' }) })),
      });
    case INVESTMENT_PREFERENCE:
      return yup.object().shape({
        [INVESTMENT_PREFERENCE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentPreference' }) })),
      });

    case INVESTMENT_EXP_BONDS_YRS:
      return yup.object().shape({
        [INVESTMENT_EXP_BONDS_YRS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.bonds' }) })),
      });
    case INVESTMENT_EXP_EQUITIES_YRS:
      return yup.object().shape({
        [INVESTMENT_EXP_EQUITIES_YRS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.equities' }) })),
      });
    case INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS:
      return yup.object().shape({
        [INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.privateEquityHedgeFunds' }) })),
      });
    case INVESTMENT_EXP_REAL_ESTATE_YRS:
      return yup.object().shape({
        [INVESTMENT_EXP_REAL_ESTATE_YRS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.realEstate' }) })),
      });
    case INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS:
      return yup.object().shape({
        [INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.otherAlternative' }) })),
      });

    case INDEPENDENT_PROF_ADVICE:
      return yup.object().shape({
        [INDEPENDENT_PROF_ADVICE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.accessToIndependent' }) })),
      });
    // case INVESTMENT_OBJECTIVE_TIME_HORIZON:
    //   return yup.object().shape({
    //     [INVESTMENT_OBJECTIVE_TIME_HORIZON]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentObj' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentObj' }) }),
    //         (value) => {
    //           if (isDiscretionary && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    // case ASSET_CLASSES:
    //   return yup.object().shape({
    //     [ASSET_CLASSES]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.assetClasses' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.assetClasses' }) }),
    //         (value) => {
    //           if (isDiscretionary && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    // case MARKETS:
    //   return yup.object().shape({
    //     [MARKETS]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.markets' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.markets' }) }),
    //         (value) => {
    //           if (isDiscretionary && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    // case INVESTMENT_KNOWLEDGE:
    //   return yup.object().shape({
    //     [INVESTMENT_KNOWLEDGE]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' }) }),
    //         (value) => {
    //           if (isDiscretionary && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    // case RESTRICTIONS:
    //   return yup.object().shape({
    //     [RESTRICTIONS]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.restrictions' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.restrictions' }) }),
    //         (value) => {
    //           if (isDiscretionary && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    // case OTHER_RESTRICTION:
    //   return yup.object().shape({
    //     [OTHER_RESTRICTION]: yup
    //       .string()
    //       .test(
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'restriction.pleaseSpecify' }) }),
    //         intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'restriction.pleaseSpecify' }) }),
    //         (value) => {
    //           if (isDiscretionary && (restrictions === 'NW-MAR-RES-FIVE' || restrictions === 'NW-MAR-RES-FOUR' || restrictions === 'NW-MAR-RES-THREE') && !value) return false;
    //           return true;
    //         },
    //       ),
    //   });
    default:
      return null;
  }
};

export const insiderListSchema = (intl, insiderStatus) => yup.object().shape({
  [INSIDER_STATUS_LIST]: yup.array(
    yup.object().shape({
      [INSIDER_STATUS_LIST_COMPANY]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (insiderStatus === 'insiderStatus-yes' && !value) {
              return false;
            }
            return true;
          },
        ),
      [INSIDER_STATUS_LIST_POSITION]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (insiderStatus === 'insiderStatus-yes' && !value) {
              return false;
            }
            return true;
          },
        ),
    }),
  ),
});

// isDiscretionary, restrictions, clientClassification, typeOfInvestment
export const clientProfilePageSchema = intl => yup.object().shape({
  // [GOAL]: yup
  //   .string()
  //   .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.goal' }) })),
  [INVESTMENT_PURPOSE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentPurpose' }) })),
  [RISK_TOLERANCE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.riskTolerance' }) })),
  [INVESTMENT_PREFERENCE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentPreference' }) })),
  [INVESTMENT_EXP_BONDS_YRS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.bonds' }) })),
  [INVESTMENT_EXP_EQUITIES_YRS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.equities' }) })),
  [INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.privateEquityHedgeFunds' }) })),
  [INVESTMENT_EXP_REAL_ESTATE_YRS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.realEstate' }) })),
  [INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.otherAlternative' }) })),
  [INDEPENDENT_PROF_ADVICE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.accessToIndependent' }) })),

  // [INVESTMENT_OBJECTIVE_TIME_HORIZON]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentObj' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentObj' }) }),
  //     (value) => {
  //       if (isDiscretionary && !value) return false;
  //       return true;
  //     },
  //   ),
  // [ASSET_CLASSES]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.assetClasses' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.assetClasses' }) }),
  //     (value) => {
  //       if (isDiscretionary && !value) return false;
  //       return true;
  //     },
  //   ),
  // [MARKETS]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.markets' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.markets' }) }),
  //     (value) => {
  //       if (isDiscretionary && !value) return false;
  //       return true;
  //     },
  //   ),
  // [INVESTMENT_KNOWLEDGE]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.investmentKnowledge' }) }),
  //     (value) => {
  //       if (isDiscretionary && !value) return false;
  //       return true;
  //     },
  //   ),
  // [RESTRICTIONS]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.restrictions' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.restrictions' }) }),
  //     (value) => {
  //       if (isDiscretionary && !value) return false;
  //       return true;
  //     },
  //   ),
  // [OTHER_RESTRICTION]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'restriction.pleaseSpecify' }) }),
  //     intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'restriction.pleaseSpecify' }) }),
  //     (value) => {
  //       if (isDiscretionary && (restrictions === 'NW-MAR-RES-FIVE' || restrictions === 'NW-MAR-RES-FOUR' || restrictions === 'NW-MAR-RES-THREE') && !value) return false;
  //       return true;
  //     },
  //   ),
});
